module.exports = __webpack_public_path__ + "static/media/lumber-84678_1920.db4e897d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lumber-84678_1920.jpg
// module id = 45
// module chunks = 0